import { Organisation } from './organisation';
import { Application } from './application';

export class LaunchpadUser {
  id: string = '';
  type: string = '';
  name: string = '';
  firstName: string = '';
  surname: string = '';
  emailAddress: string = '';
  isActive: boolean = false;
  isExternal: boolean = false;
  deactivationDate?: Date | null;
  impersonationExpiry?: Date | null;
  lastLogin?: Date | null;
  isTeamMember: boolean = false;
  disableTeamMemberRestriction: boolean = false;
  organisations: Organisation[] = [];
  apps?: Application[];

  constructor(user: {
    id: string,
    type: string,
    name: string;
    firstName: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    isExternal: boolean;
    deactivationDate?: Date | null;
    impersonationExpiry?: Date | null;
    lastLogin?: Date | null;
    isTeamMember: boolean;
    disableTeamMemberRestriction: boolean;
    organisations: Organisation[];
    apps?: Application[];
  }) {
    this.id = user.id ?? this.id;
    this.type = user.type ?? this.type;
    this.name = user.name ?? this.name;
    this.firstName = user.firstName ?? this.firstName;
    this.surname = user.surname ?? this.surname;
    this.emailAddress = user.emailAddress ?? this.emailAddress;
    this.isActive = user.isActive ?? this.isActive;
    this.isExternal = user.isExternal ?? this.isExternal;
    this.deactivationDate = user.deactivationDate ?? this.deactivationDate;
    this.impersonationExpiry = user.impersonationExpiry ?? this.impersonationExpiry;
    this.lastLogin = user.lastLogin ?? this.lastLogin;
    this.isTeamMember = user.isTeamMember ?? this.isTeamMember;
    this.disableTeamMemberRestriction = user.disableTeamMemberRestriction ?? this.disableTeamMemberRestriction;
    this.organisations = user.organisations ?? this.organisations;
    this.apps = user.organisations ? this.computeUserAllApps(user.organisations) : this.apps;
  };

  public static fromLaunchpadUserDto(user: LaunchpadUserDto): LaunchpadUser {
    return new LaunchpadUser({
      id: user.id,
      type: user.type,
      name: user.name,
      firstName: user.firstName,
      surname: user.surname,
      emailAddress: user.emailAddress,
      organisations: user.organisations,
      isActive: user.isActive,
      isExternal: user.isExternal,
      deactivationDate: user.deactivationDate ? new Date(user.deactivationDate) : null,
      impersonationExpiry: user.impersonationExpiry ? new Date(user.impersonationExpiry) : null,
      lastLogin: user.lastLogin ? new Date(user.lastLogin) : null,
      isTeamMember: user.isTeamMember,
      disableTeamMemberRestriction: user.disableTeamMemberRestriction
    });
  }

  private computeUserAllApps(organisations: Organisation[]): Application[] {
    const userAppList = organisations.map(o => o.applications ?? []).flat();
    const appMap = new Map(userAppList.map(item => [item.id, item]));
    return [...appMap.values()];
  }
}

export interface LaunchpadUserDto {
  id: string;
  type: string;
  name: string;
  firstName: string;
  surname: string;
  emailAddress: string;
  isActive: boolean;
  isExternal: boolean;
  deactivationDate?: string;
  impersonationExpiry?: string;
  lastLogin?: string;
  isTeamMember: boolean;
  disableTeamMemberRestriction: boolean;
  organisations: Organisation[];
  apps?: Application[];
}